import {
    ActionService,
    collection,
    ConfigurationService,
    EntityData,
    field,
    JwtHttpClientService,
    ResourceModule
} from "@fedelta-pos/data-client";
import {Inject, Injectable} from "@angular/core";
import {OrderInitiationData} from "../order/order-initiation.service";

export enum OrderTransferTargetStatus {
    OPEN = <any>"OPEN",
    CLOSED = <any>"CLOSED",
    CLOSED_TIMEOUT = <any>"CLOSED_TIMEOUT",
    CLOSED_CONFLICT = <any>"CLOSED_CONFLICT",
    SAVING = <any>"SAVING"
}

export class OrderTransferRequestsData extends EntityData<OrderTransferRequestsData> {
    @field transferTargetStatus: OrderTransferTargetStatus;
    @field transferTargetOrderType: string;
    @collection(OrderInitiationData) requests: OrderInitiationData[];
}

/**
 * Service to poll for transfer requests for a target
 */
@Injectable()
export class OrderTransferRequestPollService extends ActionService {
    constructor(http: JwtHttpClientService,
                configService: ConfigurationService,
                @Inject(ResourceModule.RESOURCE_NAMESPACE_KEY) nameSpace,
                @Inject(ResourceModule.ACTION_NAMES_KEY) actionNames) {
        console.log("--- OrderTransferRequestPollService");

        super(http, configService, nameSpace, actionNames, "web-order-transfer-request-poll");
    }
}



// WEBPACK FOOTER //
// ./src/app/group-order/order-transfer-request-poll.service.ts